import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const adminApi = axios.create({ baseURL: API });

adminApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("iza_admin_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

adminApi.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem("iza_admin_token");
      if (window.location.pathname.startsWith("/admin") && window.location.pathname !== "/admin") {
        window.location.href = "/admin";
      }
    }
    return Promise.reject(err);
  }
);

export const adminAuth = {
  login: (password) => adminApi.post("/admin/login", { password }),
  me: () => adminApi.get("/admin/me"),
  logout: () => localStorage.removeItem("iza_admin_token"),
  setToken: (t) => localStorage.setItem("iza_admin_token", t),
  getToken: () => localStorage.getItem("iza_admin_token"),
};

export const leadsApi = {
  list: (status) => adminApi.get("/admin/leads", { params: status ? { status } : {} }),
  stats: () => adminApi.get("/admin/leads/stats"),
  update: (id, payload) => adminApi.patch(`/admin/leads/${id}`, payload),
  remove: (id) => adminApi.delete(`/admin/leads/${id}`),
};

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
